export const getLayouts = () => ({
    'default': {},
    'full_width': {},
});
export const getLayoutsPDF = () => ({
    'default': {},
    'full_width': {
        containerWidth: 1100,
        sizeRows: 8,
        widthSVG: 200,
        heightSVG: 55,
        alignLegenda: 'left'
    },
});
